import { css, CSSResult } from 'lit'
import { cseButton } from 'elements/button/button.style.js'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { csTransition } from '@cloudsuite/mosaic-shared/styles/globals.style.js'


export const style: CSSResult = css`
  .cse-button-group {
    display: inline-flex;
    flex-direction: row;
  }

  cse-divider {
    --cse-divider-margin: ${csSpacing.spacing05};
    transition-duration: ${csTransition.duration};
    transition-property: opacity;
    transition-timing-function: ${csTransition.timingFunction};
    z-index: 10;
  }

  .cse-button-group:hover cse-divider {
    opacity: 0;
  }

  .variant-default {
    --cse-divider-border-color: ${cseButton.defaultColor};
  }

  .variant-primary {
    --cse-divider-border-color: ${cseButton.primaryColor};
  }

  .variant-secondary {
    --cse-divider-border-color: ${cseButton.secondaryColor};
  }

  .variant-error {
    --cse-divider-border-color: ${cseButton.errorColor};
  }

  .variant-info {
    --cse-divider-border-color: ${cseButton.infoColor};
  }

  .variant-success {
    --cse-divider-border-color: ${cseButton.successColor};
  }

  .variant-warning {
    --cse-divider-border-color: ${cseButton.warningColor};
  }
`
